import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Setup from "@/pages/Setup";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Kunden from "@/pages/Kunden";
import Auftraege from "@/pages/Auftraege";
import AuftragDetail from "@/pages/AuftragDetail";
import Nutzer from "@/pages/Nutzer";
import Einstellungen from "@/pages/Einstellungen";
import Anfragen from "@/pages/Anfragen";
import AnfrageDetail from "@/pages/AnfrageDetail";
import EmailQueue from "@/pages/EmailQueue";
import Aufgaben from "@/pages/Aufgaben";
import MeinProfil from "@/pages/MeinProfil";
import Versand from "@/pages/Versand";
import { ZahlungErfolg, ZahlungAbgebrochen } from "@/pages/Zahlung";
import AngebotPortal from "@/pages/AngebotPortal";
import VersionCheck from "@/components/VersionCheck";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <VersionCheck />
      <Routes>
        <Route path="/setup" element={<Setup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/zahlung/erfolg" element={<ZahlungErfolg />} />
        <Route path="/zahlung/abgebrochen" element={<ZahlungAbgebrochen />} />
        <Route path="/angebot/:token" element={<AngebotPortal />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/anfragen" element={<Anfragen />} />
          <Route path="/anfragen/:id" element={<AnfrageDetail />} />
          <Route path="/kunden" element={<Kunden />} />
          <Route path="/auftraege" element={<Auftraege />} />
          <Route path="/auftraege/:id" element={<AuftragDetail />} />
          <Route path="/versand" element={<Versand />} />
          <Route path="/aufgaben" element={<Aufgaben />} />
          <Route path="/mein-profil" element={<MeinProfil />} />
          <Route path="/nutzer" element={<Nutzer />} />
          <Route path="/einstellungen" element={<Einstellungen />} />
          <Route path="/einstellungen/email-warteschlange" element={<EmailQueue />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
